'use client';

// import EditorIcon from 'lowcode/components/EditorIcon';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
// import css from './index.module.scss';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EfLink from '@elem/ui/ef-link';
import { notification } from 'antd';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { getLang } from 'lowcomp/plugins/member/utils';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { getDetailB, getDetailC, getProductC } from '../service';
import FlashSaleDE from './comps/icons/FlashSaleDE';
import FlashSaleEN from './comps/icons/FlashSaleEN';
import FlashSaleES from './comps/icons/FlashSaleES';
import FlashSaleFR from './comps/icons/FlashSaleFR';
import FlashSaleIT from './comps/icons/FlashSaleIT';
import FlashSaleJP from './comps/icons/FlashSaleJP';
import FlashSaleKR from './comps/icons/FlashSaleKR';
import Lock from './comps/icons/Lock';
import ViewModal from './comps/ViewModal';
// import UnlockModal from './comps/UnlockModal';
import getLocal from '@/app/utils/getLocal';
import Cards from './comps/Cards';
import Countdown from './comps/Countdown';
import { i18n } from './comps/i18n';
// import gtm from '@/utils/gtm';
import { getHostApi } from '@/utils';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { getWSSUrl } from '@/utils/countryRegion';
import gtm from '@/utils/gtm';
import wss from '@/utils/mqtt-client';
import topics from '@/utils/mqtt-client/crowd-funding-topics';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { useGlobal } from '@/utils/useGlobal';

notification.config({
    placement: 'bottomRight',
    bottom: 60,
    duration: 5,
});

const MAX_NUM = 6;

export default function Content({ data, isEditStatus }: any) {
    const { locale, query, asPath = '' } = getLocal();
    // const isPreview = pathname.indexOf('/preview/') !== -1;
    const t = getLang(i18n, locale);
    const [isLogin, setIsLogin] = useState(false);
    const [showView, setShowView] = useState(false);
    // const [showUnlock, setShowUnlock] = useState(false);
    const { eventTheme, eventTitleColor, eventSubtitleColor, eventCountBgColor, eventCountNumberColor, eventCountTextColor, ...rest } = data;
    const [campaignId, setCampaignId] = useState('');
    const [form, setForm] = useState();
    const [event, setEvent] = useState();
    const [cards, setCards] = useState();
    const [segment, setSegment] = useState();
    const [showC, setShowC] = useState(false);
    // let now = new Date().getTime();
    const [showCartIcon, setShowCartIcon] = useState(false);
    const { getSystemTime } = useGlobal();
    const sysTime = getSystemTime();
    let serverTime = sysTime; // 变
    const [timeNow, setTimeNow] = useState(sysTime);
    let serverTime2 = sysTime; // 不变
    const timer: any = useRef(null);
    const [cardItemsInfo, setCardItemsInfo] = useState([]);
    const [init1, setInit1] = useState(false);
    const [init2, setInit2] = useState(false);
    const [init3, setInit3] = useState(false);

    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [isOpenMore, setIsOpenMore] = useState(false);

    const format = (time: number) => {
        const ts = Math.floor(time / 1000);
        const d = String(Math.floor(ts / 3600 / 24)).padStart(2, '0');
        const h = String(Math.floor((ts / 3600) % 24)).padStart(2, '0');
        const m = String(Math.floor((ts / 60) % 60)).padStart(2, '0');
        const s = String(Math.floor(ts % 60)).padStart(2, '0');
        return { d, h, m, s };
    };

    const iconMap = {
        en: <FlashSaleEN style={{ color: eventTheme }} />,
        de: <FlashSaleDE style={{ color: eventTheme }} />,
        fr: <FlashSaleFR style={{ color: eventTheme }} />,
        it: <FlashSaleIT style={{ color: eventTheme }} />,
        es: <FlashSaleES style={{ color: eventTheme }} />,
        jp: <FlashSaleJP style={{ color: eventTheme }} />,
        kr: <FlashSaleKR style={{ color: eventTheme }} />,
        br: <FlashSaleEN style={{ color: eventTheme }} />,
        mx: <FlashSaleEN style={{ color: eventTheme }} />,
        ph: <FlashSaleEN style={{ color: eventTheme }} />,
    };

    const handlerClickView = () => {
        setShowView(true);
    };

    // 秒杀阶段 -1 活动未开始 0 秒杀前 1 秒杀中 2 秒杀后 3 活动已结束 4 未知异常或其他
    const getActiveStatu = (formData: any, serverTime: any, campaignStartTimeStamp: any, campaignEndTimeStamp: any) => {
        return serverTime < campaignStartTimeStamp
            ? -1
            : formData?.events?.find(
                  (ev: any) =>
                      serverTime >= new Date(`${ev?.seckillStartTime.replaceAll('-', '/')} GMT+8`).getTime() &&
                      serverTime < new Date(`${ev?.seckillEndTime.replaceAll('-', '/')} GMT+8`).getTime(),
              )
            ? 1
            : formData?.events?.find((ev: any) => serverTime < new Date(`${ev?.seckillStartTime.replaceAll('-', '/')} GMT+8`).getTime())
            ? 0
            : serverTime < campaignEndTimeStamp
            ? 2
            : serverTime >= campaignEndTimeStamp
            ? 3
            : 4;
    };

    const initData = (formData: any) => {
        if (!formData) return;
        setForm(formData || {});
        // API 邮箱订阅
        if (formData?.apiSetting && formData?.subscribeFlag) {
            const { apiSetting } = formData;
            apiSetting?.fields?.map((field) => {
                if (field.type === 'multiple') {
                    if (typeof field.value === 'string') {
                        field.value = field.value.split(',') || [];
                    }
                    field.value?.map((num) => Number(num));
                }
                if (field.type === 'single') {
                    if (typeof field.value === 'string') {
                        field.value = Number(field.value);
                    }
                }
            });
        }
        const campaignStartTimeStamp = new Date(`${formData.campaignStartTime?.replaceAll('-', '/')} GMT+8`).getTime();
        const campaignEndTimeStamp = new Date(`${formData.campaignEndTime?.replaceAll('-', '/')} GMT+8`).getTime();
        const IS_ACTIVE = serverTime >= campaignStartTimeStamp && serverTime < campaignEndTimeStamp;
        const showPage = IS_ACTIVE || isEditStatus;
        // 编辑模式 可以切换秒杀阶段
        if (isEditStatus) {
            const target = formData?.events[0];
            setEvent(target || {});
            setShowCartIcon(data?.eventSegment === 2 && target?.products?.some((p) => p?.currentBtns?.includes('4')));
            if (data?.eventSegment === 3) {
                const newSeg = target?.segments[2];
                if (target?.segments[2]?.processMethod === 1) {
                    setShowC(false);
                } else {
                    setShowC(showPage);
                }
                if (target?.segments[2]?.processMethod === 2) {
                    const { title, subtitle, viewSteps, inventoryStyle, hidePrice, otherFunction } = target?.segments[1];
                    setSegment({ ...newSeg, title, subtitle, viewSteps, inventoryStyle, hidePrice, otherFunction });
                } else {
                    setSegment(newSeg || {});
                }
            } else {
                serverTime = new Date(
                    data?.eventSegment === 2 ? target.seckillEndTime?.replaceAll('-', '/') : `${target.seckillStartTime?.replaceAll('-', '/')} GMT+8`,
                ).getTime();
                setTimeNow(serverTime);
                setSegment(target?.segments[(data?.eventSegment || 1) - 1] || {});
                setShowC(showPage);
            }
            return;
        }
        // 秒杀阶段 -1 活动未开始 0 秒杀前 1 秒杀中 2 秒杀后 3 活动已结束 4 未知异常
        const INIT_ACTIVE_STATU = getActiveStatu(formData, serverTime, campaignStartTimeStamp, campaignEndTimeStamp);

        if ([-1, 0, 1, 2].includes(INIT_ACTIVE_STATU)) {
            if (timer.current) {
                clearInterval(timer.current);
                timer.curren = null;
            }
            timer.current = setInterval(() => {
                if (query?._timer) {
                    if (serverTime === serverTime2) {
                        serverTime2 = serverTime = new Date(`${query?._timer.replaceAll('-', '/')} GMT+8`).getTime();
                        setTimeNow(serverTime);
                    }
                }
                const NEW_ACTIVE_STATU = getActiveStatu(formData, serverTime, campaignStartTimeStamp, campaignEndTimeStamp);
                if ([3, 4].includes(NEW_ACTIVE_STATU)) {
                    clearInterval(timer?.current);
                }
                // 预览 + C端 整个活动范围内
                if (IS_ACTIVE) {
                    let target = null;
                    let curEventIdx = -1;
                    let stage = 0;
                    // 秒杀中
                    formData?.events?.map((event, k) => {
                        if (
                            new Date(`${event?.seckillStartTime.replaceAll('-', '/')} GMT+8`).getTime() <= serverTime &&
                            new Date(`${event?.seckillEndTime.replaceAll('-', '/')} GMT+8`).getTime() > serverTime &&
                            !target
                        ) {
                            if (cardItemsInfo?.length > 0) {
                                event?.products?.map((p: any) => {
                                    const targetInfo = cardItemsInfo?.find((info) => info?.id === p?.id);
                                    if (targetInfo) {
                                        p = JSON.parse(JSON.stringify({ ...p, ...targetInfo }));
                                    }
                                });
                            }
                            target = event;
                            curEventIdx = k;
                            stage = 1;
                        }
                    });
                    // 秒杀前
                    if (!target) {
                        formData?.events?.map((event, k) => {
                            if (serverTime < new Date(`${event?.seckillStartTime.replaceAll('-', '/')} GMT+8`).getTime() && !target) {
                                target = event;
                                curEventIdx = k;
                                stage = 0;
                            }
                        });
                    }
                    // 秒杀后
                    if (!target) {
                        formData?.events?.find((event, k) => {
                            if (
                                serverTime >= new Date(`${event?.seckillEndTime.replaceAll('-', '/')} GMT+8`).getTime() &&
                                !target &&
                                ((k === curEventIdx && curEventIdx !== -1) || curEventIdx === -1)
                            ) {
                                target = event;
                                curEventIdx = k;
                                stage = 2;
                            }
                        });
                    }
                    setEvent(target || {});
                    setSegment(target.segments[stage]);
                    setShowCartIcon(NEW_ACTIVE_STATU === 1 && target?.products?.some((p) => p?.currentBtns?.includes('4')));
                    if (NEW_ACTIVE_STATU === 2) {
                        const newSeg = target?.segments[2];
                        if (newSeg?.processMethod === 1) {
                            setShowC(false);
                        } else {
                            setShowC(showPage);
                        }
                        if (newSeg?.processMethod === 2) {
                            const { title, subtitle, viewSteps, inventoryStyle, hidePrice, otherFunction } = target?.segments[1];
                            setSegment({ ...newSeg, title, subtitle, viewSteps, inventoryStyle, hidePrice, otherFunction });
                        } else {
                            setSegment(newSeg || {});
                        }
                    } else {
                        setShowC(showPage);
                        setSegment(target?.segments[NEW_ACTIVE_STATU] || {});
                    }
                }
                serverTime += 1000;
                setTimeNow(serverTime);
            }, 1000);
        } else {
            clearInterval(timer?.current);
        }
    };

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTime = getSystemTime();
            setTimeNow(serverTime);
            // 测试环境异常
            if (serverTime < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTime = globalData?.data?.timestamp || new Date().getTime();
                        setTimeNow(serverTime);
                    } catch (e) {
                        console.error(e);
                    }
                })();
            }
        }
    };

    const handleAddCart = (card: any) => {
        const result = JSON.parse(JSON.stringify(shoppingCarts));
        const target = result?.find((item: any) => item?.variantId === card?.variantId);
        if (target) {
            target.quantity = target.quantity + 1;
        } else {
            if ((card?.inventoryQuantity && card?.inventoryQuantity > 0) || (!card?.inventoryQuantity && card?.inventoryQuantity !== 0)) {
                result.push({
                    productId: card?.productId,
                    variantId: card?.variantId,
                    quantity: 1,
                    title: card?.title,
                    discountPrice: card?.memberPrice,
                    originalPrice: card?.compareAtPrice ?? card?.price,
                    img: card?.imgUrl,
                });
            }
        }
        //setShoppingCarts(result);
        EcoDesignEventsBus.emit('eco-cart-add', result);
        setVisible(true);
        let tag = '';
        if (card?.discountTagType === 1) {
            tag = FormatMoneyLocal((card?.compareAtPrice ?? card?.price) - (card?.memberPrice ?? card?.price), locale) + t('card_tag_off');
        } else if (card?.discountTagType === 2) {
            if (card?.countRetention === 1) {
                tag = `${Math.round(100 * (1 - (card?.memberPrice ?? card?.price) / (card?.compareAtPrice ?? card?.price)))}%${t('card_tag_off')}`;
            }
            if (card?.countRetention === 2) {
                tag = `${Math.floor(100 * (1 - (card?.memberPrice ?? card?.price) / (card?.compareAtPrice ?? card?.price)))}%${t('card_tag_off')}`;
            }
        } else if (card?.discountTagType === 3) {
            tag = card?.discountTagText;
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: segment?.title,
            product_name: card?.title,
            price: card?.memberPrice,
            tag,
            quantity: 1,
            button_name: t('card_btn_add_cart'),
        });
    };

    const handleCallback = (carts: any[], isClose?: boolean) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
    };

    const handleToggleMore = () => {
        setIsOpenMore(!isOpenMore);
    };

    useEffect(() => {
        if (init3) {
            event?.products?.map((p: any) => {
                const aim = cardItemsInfo?.find((info: any) => p?.id === info?.id);
                if (aim) {
                    p.variantId = aim?.variantId;
                    p.productId = aim?.productId;
                    p.checkoutUrl = aim?.checkoutUrl;
                    p.productUrl = aim?.productUrl;
                }
            });
            setCards(JSON.parse(JSON.stringify(isOpenMore ? event?.products : event?.products?.slice(0, MAX_NUM) || '[]')));
        }
    }, [event, isOpenMore, init3, segment, cardItemsInfo]);

    useEffect(() => {
        // 测试环境异常
        if (serverTime < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTime = globalData?.data?.timestamp || new Date().getTime();
                    setTimeNow(serverTime);
                } catch (e) {
                    console.error(e);
                }
            })();
        }

        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    const initAPI = async () => {
        const API = isEditStatus ? getDetailB : getDetailC;
        const { key, _timer } = query;
        const res = key && _timer ? await API(locale, data?.campaignId, key, decodeURIComponent(_timer)) : await API(locale, data?.campaignId);
        if (res?.code === '0') {
            setInit1(true);
            initData(JSON.parse(JSON.stringify(res?.data || '{}')));
        } else {
            // notification.error({ message: res?.message || '获取秒杀活动详情失败！' });
            console.error(res?.message || '获取秒杀活动详情失败！');
        }
    };

    useEffect(() => {
        if (data?.campaignId && !init1) {
            if (campaignId !== data?.campaignId) {
                setCampaignId(data?.campaignId);
            }
            initAPI();
        }
    }, [data?.campaignId, isEditStatus, data?.eventSegment]);

    const getProductLink = async (card: any, arr: any[]) => {
        const { key, _timer } = query;
        const data: { id: string | number; token?: string; expectedNow?: string } = { id: card?.id };
        if (key && _timer) {
            data.token = key || '';
            data.expectedNow = decodeURIComponent(_timer);
        }
        const res = await getProductC(data, locale);
        if (res?.code === '0') {
            if (res?.data) {
                arr.push({ ...res?.data, id: card?.id });
            } else {
                // notification.error({ message: '当前秒杀活动未开启或当前时间不在整体秒杀活动时间范围内' });
                console.error('当前秒杀活动未开启或当前时间不在整体秒杀活动时间范围内');
            }
        } else {
            // 活动结束后\未开始时不抛错
            // if (['2472', '2470'].includes(res?.code)) return;
            // notification.error({ message: res?.message });
            console.error(res?.message);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && !isEditStatus) {
            setIsClient(true);
        }
    }, [isEditStatus]);

    useEffect(() => {
        if (isEditStatus) return;
        //console.log('event', event);

        let flag = true;
        if (event?.products?.length > 0 && event?.seckillEndTime && event?.seckillStartTime) {
            const { seckillStartTime, seckillEndTime } = event;
            const curSegment =
                serverTime >= new Date(`${seckillEndTime.replaceAll('-', '/')} GMT+8`).getTime()
                    ? 3
                    : serverTime >= new Date(`${seckillStartTime.replaceAll('-', '/')} GMT+8`).getTime()
                    ? 2
                    : 1;
            if (curSegment === 3) {
                flag = false;
            } else {
                flag = event.products?.some((p) => !(p?.productUrl && p?.checkoutUrl));
            }
        }

        if (init1 && flag) {
            const newCards = JSON.parse(JSON.stringify(event?.products) || '[]');
            const promises: any[] = [];
            const arr: any[] = [];
            newCards.forEach((card: any, k: number) => {
                promises.push(getProductLink(card, arr));
            });
            if (promises?.length > 0) {
                Promise.all(promises)
                    .then(() => {
                        setCardItemsInfo(JSON.parse(JSON.stringify(arr)));
                        setInit2(true);
                    })
                    .catch(() => {
                        // notification.error({ message: '获取产品卡片失败' });
                        console.log('获取产品卡片失败');
                    });
            }
        }
    }, [isEditStatus, event, segment]);

    useEffect(() => {
        if (init1 && init2) {
            initData(JSON.parse(JSON.stringify(form)));
            setInit3(true);
        }
    }, [init1, init2]);

    // console.log('data?.campaignId', data?.campaignId, campaignId);
    const { receiver, mqttUnsubscribe, mqttSubscribe } = wss({
        url: String(getWSSUrl(locale)),
        topics,
        locale,
        subscribes: ['flashSale'],
        activityId: data?.campaignId || campaignId,
    });

    useEffect(() => {
        const { data } = receiver;
        if (data) {
            initData(JSON.parse(JSON.stringify(data)));
        }
    }, [receiver]);

    useEffect(() => {
        mqttSubscribe('flashSale');
        return () => mqttUnsubscribe('flashSale');
    }, []);

    return (
        <>
            {showC && (
                <div
                    className={`eco-flash-sale-box${segment?.segment === 3 && segment?.processMethod === 2 ? ' gray' : ''} GtmModuleData-section`}
                    data-section-id={'Member-FlashSale'}
                    data-section-title={segment?.title || 'Member-FlashSale'}
                >
                    {form && event && segment ? (
                        <>
                            <div className="info-box">
                                {segment?.title && (
                                    <div className="title-box">
                                        {!['br', 'mx'].includes(locale) && (iconMap[locale] || iconMap.en)}
                                        <p className="sale-title" style={{ color: eventTitleColor }}>
                                            {segment?.title}
                                        </p>
                                    </div>
                                )}
                                {segment?.subtitle && (
                                    <p className="desc" style={{ color: eventSubtitleColor }}>
                                        {segment?.subtitle}
                                    </p>
                                )}
                                {segment?.viewSteps && (
                                    <p className="view-steps" onClick={handlerClickView} style={{ color: eventTheme }}>
                                        {t('view_steps')}
                                    </p>
                                )}
                            </div>
                            {form?.subscribeFlag && form?.apiSetting && segment?.otherFunction === 1 && (
                                <EfEmarsysEmail
                                    needTerms={true}
                                    configTheme={eventTheme}
                                    termsTextColor={data?.cardBgColor}
                                    configCheck={form.termsFlag}
                                    termsHtml={t('email_terms')}
                                    tipsObj={{
                                        btnText: t('email_btn'),
                                        placeholder: t('email_placeholder'),
                                        tipsEmpty: t('email_tips_empty'),
                                        tipsTypeError: t('email_tips_type_error'),
                                        successTips: t('email_success_tips'),
                                        tipsCheck: t('email_tips_check'),
                                    }}
                                    {...form.apiSetting}
                                />
                            )}
                            {segment?.otherFunction === 2 && (
                                <Countdown
                                    dateObj={(() => {
                                        const endTime =
                                            segment?.segment === 1
                                                ? event?.seckillStartTime?.replaceAll('-', '/')
                                                : event?.seckillEndTime?.replaceAll('-', '/');
                                        const endTimeStamp = new Date(`${endTime} GMT+8`).getTime();
                                        if (timeNow < endTimeStamp) {
                                            return format(endTimeStamp - timeNow);
                                        }
                                        return { d: '00', h: '00', m: '00', s: '00' };
                                    })()}
                                    eventCountBgColor={eventCountBgColor}
                                    eventCountNumberColor={eventCountNumberColor}
                                    eventCountTextColor={eventCountTextColor}
                                />
                            )}
                            {event?.products?.length > 0 && (
                                <Cards
                                    campaignId={campaignId}
                                    eventTheme={eventTheme}
                                    cards={cards}
                                    isOpenMore={isOpenMore}
                                    segment={segment}
                                    isLogin={isLogin}
                                    isEditStatus={isEditStatus}
                                    // isPreview={isPreview}
                                    showCartIcon={showCartIcon}
                                    handleToggleMore={handleToggleMore}
                                    handleAddCart={handleAddCart}
                                    {...rest}
                                />
                            )}
                            {!isLogin && [1, 2].includes(segment.segment) && event?.products?.length > 0 && (
                                <EfLink
                                    className="btn-unlock"
                                    style={{ backgroundColor: eventTheme }}
                                    href={`/${locale}/login?redirect=/${locale}${asPath}`}
                                    onClick={() => {
                                        signupCookie?.({
                                            sector_name: 'Flash Sale',
                                            entry_position: 0,
                                        });
                                    }}
                                    target="_self"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'activity_button',
                                        // page_name: '$pageName',
                                        list_name: segment?.title,
                                        button_name: form?.unlockText,
                                        function: 'Unlock',
                                    }}
                                    // onClick={() => {
                                    //     // setShowUnlock(true);
                                    //     gtm.push({
                                    //         event: 'uaEvent',
                                    //         event_name: 'activity_button',
                                    //         // page_name: '$pageName',
                                    //         list_name: segment?.title,
                                    //         button_name: form?.unlockText,
                                    //         function: 'Unlock',
                                    //     });
                                    // }}
                                >
                                    <Lock />
                                    <span className="unlock-text">{form?.unlockText}</span>
                                </EfLink>
                            )}
                            {showView && <ViewModal text={segment?.viewSteps} callback={() => setShowView(false)} />}
                            {/* {showUnlock && (
                                <UnlockModal
                                    segmemtTitle={segment?.title}
                                    unlockText={form?.unlockText}
                                    theme={eventTheme}
                                    callback={() => setShowUnlock(false)}
                                />
                            )} */}
                        </>
                    ) : (
                        <div className="out-of-time">{isEditStatus ? '右侧请选择秒杀活动ID 或 选择秒杀阶段' : ''}</div>
                    )}
                    {visible &&
                        isClient &&
                        showCartIcon &&
                        createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
                    {isClient &&
                        showCartIcon &&
                        createPortal(
                            <ShopifyCartIcon
                                quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                                    return prev + Number(curItem.quantity);
                                }, 0)}
                                callback={() => setVisible(true)}
                            />,
                            document.body,
                        )}
                </div>
            )}
        </>
    );
}
